import React, { useEffect } from "react";
import { ConsultantDetailsList } from "../Utils/addConsultantInput";
import { useGetConsultantDetailsQuery } from "../../../../Service/consultant";
import { useDispatch } from "react-redux";
import { Change } from "../../../../store/async-actions/digitalmarketing/header";

const ConsultantDetails = ({ consultantid }:any) => {
  const dispatch = useDispatch()
  const { data: consultantData, refetch } = useGetConsultantDetailsQuery(
    { id: consultantid },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const Consultant = consultantData?.data;
  console.log(Consultant?.consultantName,"consultantNameconsultantName");

  useEffect(() => {
    const data: any = {
      first: `${Consultant?.consultantName}`
    };
    dispatch(Change(data));
  }, [consultantData]);
  return (
    <div className="Customer-details mx-3 item2">
      <ul className="md-bord">
        <li>
          <img
            src={require(`../../../../assets/DigitalMarketing/image/customer/avt.png`)}
            className="me-2"
            alt="i"
            style={{ height: "60px", width: "60px" }}
          />
          <p
            className="d-inline Inter-Regular fw-600 mt-2 f-24 mb-0"
            style={{ height: "0px" }}
          >
            {Consultant?.consultantName}
          </p>
        </li>
        {ConsultantDetailsList.map((a, i) => {
          if (a.break) {
            return (
              <li>
                <hr></hr>
              </li>
            );
          } else if (a.title) {
            return (
              <li>
                <p className="mt-2 mb-1 f-18 fw-500">{a.title}</p>
              </li>
            );
          }
          return (
            <li className="input-custom" key={i}>
              <span className="det-label">
                <img
                  src={require(`../../../../assets/DigitalMarketing/image/customer/${a.img}.png`)}
                  className="me-2"
                  alt="i"
                />
                {a.label}
              </span>
              <p className="text-custom" style={{ height: "0px" }}>
                {Consultant?.[a.name] ? Consultant[a.name] : "-"}
              </p>
            </li>
          );
        })}
        <li className="list-item">
          <div className="others" style={{ background: "#D5ECE2" }}>
            <dt className="f-14 fw-400">Revenue</dt>
            <dd className="f-22" style={{ color: "#439F77" }}>
              <strong>{consultantData?.Revenue}</strong>
            </dd>
          </div>
          <div className="others" style={{ background: "#F6D7C5" }}>
            <dt className="f-14 fw-400">Appointments</dt>
            <dd className="f-22" style={{ color: "#EE661A" }}>
              <strong>{consultantData?.Appointments}</strong>
            </dd>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default ConsultantDetails;
